import { fromConsignmentItemDetailsResponseV3, toUpdateConsignmentItemRequest } from '../models/mapper'
import { ConsignmentItemUpdate } from '../models/request'
import { ConsignmentItemDetails } from '../models/types'
import { updateConsignmentItemDraftV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateConsignmentItemDraft(id: number, data: ConsignmentItemUpdate): Promise<ConsignmentItemDetails> {
  const response = await updateConsignmentItemDraftV3(id, toUpdateConsignmentItemRequest(data))
  return fromConsignmentItemDetailsResponseV3(response)
}
